import * as stylex from '@stylexjs/stylex';
import _ from 'lodash';

import { useTranslation } from 'react-i18next';
import { DailyScheduleType } from '@/schedule/schedule.types';
import { Checkbox } from '@seeqdev/qomponents';

const SCHEDULE_TYPE_TRANSLATIONS = {
  [DailyScheduleType.EVERY_DAY]: 'SCHEDULE_TYPE.DAILY.EVERY_DAY',
  [DailyScheduleType.EVERY_WEEKDAY]: 'SCHEDULE_TYPE.DAILY.WEEKDAYS',
};

interface DailyScheduleProps {
  selectedType: DailyScheduleType;
  onSelect: (dailyScheduleType: DailyScheduleType) => void;
  disabled?: boolean;
}

/**
 * Selector for day frequency
 */
export const DailySchedule = ({ selectedType, onSelect, disabled = false }: DailyScheduleProps) => {
  const { t } = useTranslation();

  return (
    <div data-testid="daily-schedule-config" {...stylex.props(styles.dailySchedule)}>
      {_.map(Object.entries(SCHEDULE_TYPE_TRANSLATIONS), ([type, translation]) => {
        const id = `schedule-type-${type}`;
        const isCurrent = type === selectedType;

        return (
          <Checkbox
            id={id}
            testId={id}
            key={type}
            type="radio"
            label={t(translation)}
            checked={isCurrent}
            disabled={disabled}
            onChange={() => !isCurrent && onSelect(type as DailyScheduleType)}
          />
        );
      })}
    </div>
  );
};

const styles = stylex.create({
  dailySchedule: {
    marginBottom: '0rem',
  },
});
